import {
  ADMIN_COMPANIES_LOADED,
  ADMIN_COMPANIES_CLEAR,
} from '../actionTypes';
import * as api from '../apiHelper';
import {
  setSecondaryFetchLoaderLoading,
  setSecondaryFetchLoaderReset,
} from '../fetchLoaderActions';
import { arriveNotice } from '../noticeActions';

// --- Reducer corresponding actions ---
export function companyListLoaded(companies) {
  return {
    type: ADMIN_COMPANIES_LOADED,
    payload: { companies },
  };
}

export function companyListClear() {
  return { type: ADMIN_COMPANIES_CLEAR };
}

// --- API functions ---
async function fetchCompanyListApi(token, dispatch) {
  const response = await api.get({
    path: 'companies',
    version: 'gateway',
    token,
    dispatch,
    isAdminRoute: true,
  });
  const json = await response.json();
  return json;
}

// --- Public components actions ---
export function clearCompanyListRequest() {
  return (dispatch) => {
    dispatch(companyListClear());
  };
}

export function fetchCompanyListRequest() {
  return async (dispatch, getState) => {
    try {
      const { adminAuth: { adminToken }, fetchLoader: { dataLoading } } = getState();

      if (!dataLoading) dispatch(setSecondaryFetchLoaderLoading());
      const response = await fetchCompanyListApi(adminToken, dispatch);
      dispatch(companyListLoaded(response));
      dispatch(setSecondaryFetchLoaderReset());
    } catch (e) {
      if (e.name !== 'AbortError') {
        dispatch(setSecondaryFetchLoaderReset());
        dispatch(arriveNotice(e.message));
      }
    }
  };
}
